import { boolean, object, string } from "yup";

const defaultMessage = "This is a required field.";

export const validationSchema = object().shape({
  email: string()
    .required(defaultMessage)
    .email("Please enter a valid email address (ex: johndoe@domain.com)."),
  firstName: string().required(defaultMessage),
  privacyDealer: boolean().oneOf([true], defaultMessage),
  isDeliveryDifferent: boolean(),
  lastName: string().required(defaultMessage),
  company: string().required(defaultMessage),
  message: string().required(defaultMessage),
  billingAddress1: string().required(defaultMessage),
  billingAddress2: string(),
  billingAddressCity: string().required(defaultMessage),
  billingAddressZip: string().required(defaultMessage),
  billingAddressCountry: string().required(defaultMessage),
  deliveryAddress1: string().when("isDeliveryDifferent", {
    is: true,
    then: string().required(defaultMessage),
  }),
  deliveryAddress2: string(),
  deliveryAddressCity: string().when("isDeliveryDifferent", {
    is: true,
    then: string().required(defaultMessage),
  }),
  deliveryAddressZip: string().when("isDeliveryDifferent", {
    is: true,
    then: string().required(defaultMessage),
  }),
  deliveryAddressCountry: string().when("isDeliveryDifferent", {
    is: true,
    then: string().required(defaultMessage),
  }),
  vat: string().required(defaultMessage),
});
